module.exports = "/_next/static/images/c0dfa369bd9611bfd41a4971df95380e-secured-card-magic.png";